<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form ref="searchForm">
                    <c-form-item type="input" label="卡券编码" name="code"></c-form-item>
                    <c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
                    <c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
                    <c-form-item type="datetime" label="核销时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="input" label="使用人" name="nick_name" placeholder="用户昵称"></c-form-item>
                    <c-form-item type="input" label="手机号" name="user_mobile_phone" placeholder="用户手机号"></c-form-item>
                    <c-form-item type="input" label="关联订单号" name="order_number" placeholder="关联订单号"></c-form-item>
                    <c-form-item type="checkbox"  name="states" :options="stateDic"></c-form-item>
                </c-form>
            </m-search>
<!--            code="service_card_record_list"-->
            <c-table ref="table" >


                <c-table-column
                        label="状态"
                        name="state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 1" style="color:dodgerblue">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 2" style="color:green">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 3" style="color:orange">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 4" style="color:gray">{{stateText[data.state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="卡券编码"
                        name="code"
                        width="130"
                >
                </c-table-column>
				
				<c-table-column
				        label="商家"
				        name="company_name"
				        width="150"
				>
				</c-table-column>

                <c-table-column
                        label="商品信息"
                        name="product_name"
                        width="260"
                >
                    <template v-slot="{data}">
                        <product-info :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>
				
				<c-table-column
				        label="商品规格"
				        name="product_sku_spec"
				        width="100"
				>
				</c-table-column>

                <c-table-column
                        label="关联订单号"
                        name="order_number"
                        width="120"
                >
					<template v-slot="{data}">
						<span>{{data.order_number}}</span>
					</template>
                </c-table-column>

                <c-table-column
                        label="使用用户昵称/手机号"
                        name="topic"
                        width="150"
                >
                    <template v-slot="{data}">
                        {{data.nick_name ? data.nick_name + (data.user_manage_mobilephone ? '/' + data.user_manage_mobilephone : '') : data.user_manage_mobilephone}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="核销人"
                        name="handle_user_realname"
                        width="100"
                >
					<template v-slot="{data}">
					    {{data.used_flag==2 ? data.handle_user_realname : '-'}}
					</template>
                </c-table-column>

                <c-table-column
                        label="核销时间"
                        name="use_date"
                        width="140"
                >
					<template v-slot="{data}">
					    {{data.used_flag==2 ? data.use_date : '-'}}
					</template>
                </c-table-column>

                <c-table-column
                        label="券码发放时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>
				<c-table-column
				        label="券码有效期"
				        name="expire_date"
				        width="140"
				>
					<template v-slot="{data}">
					    <span v-if="data.state==1 || data.state==3">{{data.expire_date}}</span>
						<span v-if="data.state==2 || 4">-</span>
					</template>
				</c-table-column>
            </c-table>
        </module>
        <stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from "vuex";
    import stationedSelector from '@/components/service/stationed_selector.vue'         // 商家库
    
    export default {
        components: {
            stationedSelector,
            productInfo
        },
        name: 'm_service_card_record',

        computed: {
            ...mapState(['systemConfig']),

            stateText() {
                var state = {};
                this.stateDic.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        data() {
            return {
                stateDic: [
					{name: '待核销',value: 1},
					{name: '已核销',value: 2},
					{name: '已过期',value: 3},
					{name: '已失效',value: 4}
                ],
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/service/card/record/list',
                    data
                });
            },
            //选择商家响应事件方法
            selectStationed(data) {
                this.$refs.searchForm.set({
                    stationed_id: data[0].id,
                    company_name: data[0].company_name
                });
            },
        }
    }
</script>